<template>
  <div class="prodxq">
    <el-form ref="form" :model="form" label-width="0">


      <el-form-item label="被采集人姓名">
        <el-input v-model="form.gather_name" class="item-style"></el-input>
      </el-form-item>

      <el-form-item label="被采集人性别">

        <el-select v-model="form.gather_sex" placeholder="请选择被采集人性别" class="item-style" style="width: 100%;">
          <el-option label="男" value="男"></el-option>
          <el-option label="女" value="女"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="被采集人出生日期">
        <el-date-picker style="width: 100%;" :editable="false"
                        v-model="form.gather_time" value-format="yyyy-MM-dd"
                        type="date" :picker-options="pickerOptions"
                        placeholder="请选择被采集人出生日期">
        </el-date-picker>
      </el-form-item>


      <el-form-item label="身份证号">
        <el-input v-model="form.card" class="item-style"></el-input>
      </el-form-item>

      <el-form-item label="报告查询手机号">
        <el-input v-model="form.phone" class="item-style"></el-input>
      </el-form-item>

      <el-form-item label="收件地址">
        <el-input v-model="form.address" class="item-style"></el-input>
      </el-form-item>


      <el-form-item>
        <div class="dp-oper">
          <el-button type="info" @click="remove1">删除</el-button>
          <el-button type="primary" @click="edit1">编辑</el-button>
        </div>

      </el-form-item>

    </el-form>
  </div>
</template>

<script>

   export default {

      data() {
         return {

            form: {
               gather_id: '',
               user_id: localStorage.getItem('user_id'),
               gather_name: '',
               gather_sex: '',
               gather_time: '',
               card: '',
               phone: '',
               address: ''
            },
            pickerOptions: {
               disabledDate(time) {
                  return time.getTime() > Date.now();
               },
            }
         }
      },
      created() {
         this.form.gather_id = this.$route.params.gather_id;

         this.initData();
      },
      methods: {
         initData() {
            this.$http.api.getuserfindById({
               gather_id: this.form.gather_id
            }).then(res => {
               console.log(res)
               this.form = res

            })

         },

         remove1() {
            this.$confirm('确定删除吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning',
               center: true
            }).then(() => {
               this.$http.api.getuserdeleById({
                  gather_id: this.form.gather_id
               }).then(res => {
                  this.$message({
                     type: 'success',
                     message: '删除成功!'
                  });
                  this.$router.go(-1);
               })


            }).catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消删除'
               });
            });
         },
         edit1() {
            if (!this.form.gather_name) {
               this.$notify({
                  title: '提示',
                  message: '被采集人姓名不能为空',
                  type: 'warning',
                  duration: 2000
               })
               return false
            } else if (!this.form.gather_sex) {
               this.$notify({
                  title: '提示',
                  message: '被采集人性别不能为空',
                  type: 'warning',
                  duration: 2000
               })
               return false
            } else if (!this.form.gather_time) {
               this.$notify({
                  title: '提示',
                  message: '被采集人出生日期不能为空',
                  type: 'warning',
                  duration: 2000
               })
               return false
            } else if (!this.form.card) {
               this.$notify({
                  title: '提示',
                  message: '身份证号不能为空',
                  type: 'warning',
                  duration: 2000
               })
               return false
            } else if (!this.form.phone) {
               this.$notify({
                  title: '提示',
                  message: '报告查询手机号不能为空',
                  type: 'warning',
                  duration: 2000
               })
               return false
            } else if (!this.form.address) {
               this.$notify({
                  title: '提示',
                  message: '收件地址不能为空',
                  type: 'warning',
                  duration: 2000
               })
               return false
            }


            this.$http.api.getuseroperById({
               ...this.form
            }).then(res => {
               this.$router.go(-1);
            })


         },
      }
   }
</script>

<style lang="less">
  .el-message-box {
    width: 70%;
  }

  .prodxq {
    padding: 0.3rem;

    .el-form {
      .el-form-item {
        margin-bottom: 0.2rem;
      }
    }

    .el-form-item__label {
      line-height: 0.7rem;
      padding: 0;
      float: none;
    }
  }

  .dp-oper {
    display: flex;
    justify-content: center;
    margin: 0.3rem 0 0;

    .el-button {
      margin: 0 0.3rem;
    }
  }
</style>
